import styles from './SegmentedControl.module.css';

export type Segment<Value extends string> = {
  readonly value: Value;
  readonly label: string;
  readonly name?: string | undefined;
  readonly lang?: string | undefined;
};

export type SegmentedControlProps<Value extends string> = {
  label: string;
  segments: readonly Segment<Value>[];
  value: Value;
  onChange: (value: Value) => void;
};

export const SegmentedControl = <Value extends string>({
  label,
  segments,
  value,
  onChange,
}: SegmentedControlProps<Value>) => (
  <div role="group" aria-label={label} className={styles['segments']}>
    {segments.map((segment) => (
      <button
        key={segment.value}
        type="button"
        lang={segment.lang}
        aria-label={segment.name}
        aria-pressed={segment.value === value}
        className={styles['segment']}
        onClick={() => {
          onChange(segment.value);
        }}
      >
        {segment.label}
      </button>
    ))}
  </div>
);
